module.exports = __webpack_public_path__ + "img/461.06637f2b.jpg";